import { getState } from "../../../../state/store";
import { selectDeviceByCodentify, selectDeviceKitList } from "../../../../state/selectors";

import {
  deltaDeviceTypeOptions,
  deviceOptions,
  deviceTypeOptions,
  ilumaDeviceTypeOptions
} from "../../../../consts";
import { dateUtil, deviceGroupUtils, fwuVersionsUtil } from "../../../../utils";

const formatDeviceData = (deviceData) => {
  const {
    dusn,
    codentify,

    selectedModel,
    selectedType,

    materialBrandFamily,
    materialColor,
    materialGroup,
    materialModelNumber,

    latestFwVersion
  } = deviceData ?? {};

  const formattedVersion = latestFwVersion
    ? Object.values(latestFwVersion)
        .filter((v) => v != null)
        .join(".")
    : null;

  const result = {
    dusn,
    codentify,
    type: selectedType?.id?.toUpperCase(),
    device_model: selectedModel?.id,

    material_brand_family: materialBrandFamily,
    material_color: materialColor,
    material_group: materialGroup,
    material_model_number: materialModelNumber,

    latest_firmware_version: formattedVersion
  };

  return result;
};

const parseDeviceData = (deviceData) => {
  const {
    dusn,
    codentify,
    deviceName,
    type,
    material_brand_family,
    material_color,
    material_group,
    material_model_number,
    latest_firmware_version_update_datetime,
    latest_firmware_version
  } = deviceData ?? {};

  const deviceKitList = selectDeviceKitList()(getState());

  const selectedGroups = deviceGroupUtils.getDeviceGroupsByDusn(dusn);

  const extendedDeviceTypeOptions = [
    ...deviceTypeOptions,
    ...deltaDeviceTypeOptions,
    ...ilumaDeviceTypeOptions
  ];

  const selectedModel = deviceName ? deviceOptions.find((opt) => opt.id === deviceName) : null;
  const selectedType = type
    ? extendedDeviceTypeOptions.find((opt) => opt.id === type.toUpperCase())
    : null;

  let latestFwVersion = null;

  if (latest_firmware_version) {
    const splittedVersion = fwuVersionsUtil.splitVersion(latest_firmware_version);

    latestFwVersion = {
      major: splittedVersion[0] ?? null,
      minor: splittedVersion[1] ?? null,
      patch: splittedVersion[2] ?? null
    };
  }

  let fwuDate = null;

  if (latest_firmware_version_update_datetime) {
    try {
      fwuDate = dateUtil.getUTCDate(new Date(latest_firmware_version_update_datetime));
    } catch (e) {
      fwuDate = null;
    }
  }

  const kitCodentify =
    deviceKitList?.find((el) => el?.deviceCodentify === codentify)?.deviceKitCodentify ?? "";

  const relatedCodentify = kitCodentify
    ? deviceKitList?.find(
        (el) => el?.deviceKitCodentify === kitCodentify && el?.deviceCodentify !== codentify
      )?.deviceCodentify
    : null;

  const relatedDevice = selectDeviceByCodentify(relatedCodentify)(getState());
  const relatedDusn = relatedDevice?.dusn ?? "";

  const result = {
    dusn,
    codentify,
    selectedGroups,

    relatedDusn,
    kitCodentify,

    selectedModel,
    selectedType,

    materialBrandFamily: material_brand_family,
    materialColor: material_color,
    materialGroup: material_group,
    materialModelNumber: material_model_number,

    updateDate: fwuDate,
    updateTime: fwuDate,
    latestFwVersion
  };

  return result;
};

export const formatUtils = {
  parseDeviceData,
  formatDeviceData
};
